<template>
  <li class="relative pb-10 cursor-pointer">
    <div
      class="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-gray-300"
      :class="{ borderless: finalElement }"
    ></div>

    <e-picker
      v-if="addingElement"
      class="absolute up left-12"
      v-on:selected="addElement"
      :rank="rank"
    ></e-picker>

    <div class="relative flex items-start space-x-4 focus:outline-none">
      <div class="h-9 flex items-center group">
        <span
          class="relative w-8 h-8 flex items-center justify-center
          bg-white border-2 border-gray-300 rounded-full group-hover:border-blue-500"
          v-tooltip="buttonMessage"
          style="z-index: 5"
        >
          <span
            class="relative z-1 w-6 h-6 flex items-center justify-center
            focus:outline-none bg-gray-50 rounded-full
            group-hover:text-blue-500 group-focus:bg-gray-300 transition
            ease-in-out duration-150"
            @click="openPicker"
          >
            <!-- PLUS ELEMENT -->
            <svg
              v-if="!addingElement"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              class="h-5 w-5 focus:outline-none text-gray-300
              group-hover:text-blue-500"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
              />
            </svg>

            <!-- CANCEL -->
            <svg
              v-else
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              class="h-5 w-5 focus:outline-none text-gray-300
              group-hover:text-blue-500"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>

            <!-- Current Step -->
          </span>
        </span>
      </div>
      <div class="min-w-0" v-if="!addingElement && solo">
        <h3 class="text-md uppercase tracking-wider mt-2 text-blue-500">
          Click to add a narrative element.
        </h3>
      </div>
    </div>
    <!-- LOCK THE ELEMENTS -->
    <svg
      v-if="isLinkable && !isLinked"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      class="h-6 w-6 text-gray-300 absolute hover:text-blue-500 outline-none"
      style="top:5; left:50px"
      v-tooltip="'Link elements'"
      @click="linkElements"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2
        0 00-2 2v6a2 2 0 002 2z"
      />
    </svg>
    <!-- LOCKED UP -->
    <svg
      v-if="isLinkable && isLinked"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      class="h-6 w-6 text-gray-300 absolute hover:text-blue-500 outline-none"
      :class="{ linked: isLinked }"
      style="top:5; left:50px"
      v-tooltip="'Unlink elements'"
      @click="unlinkElements"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0
        002 2zm10-10V7a4 4 0 00-8 0v4h8z"
      />
    </svg>
  </li>
</template>

<script>
// import Component from "../component_location"
import EPicker from "./EPicker.vue";
import { EventBus } from "@/utils.js";

export default {
  components: { EPicker },

  // props: ["index", "finalElement", "solo"],
  props: {
    finalElement: { type: Boolean, default: false },
    // isLinkable: { type: Boolean, default: false },
    // isLinked: { type: Boolean, default: false },
    solo: { type: Boolean, default: false },
    rank: { type: Number, default: -1 },
  },

  data() {
    return {
      addingElement: false,
      isLinked: false,
      isLinkable: false,
    };
  },

  watch: {},

  methods: {
    addElement(elementType) {
      this.$emit("add-element", elementType);
      EventBus.$emit("close-pickers");
    },

    linkElements() {
      this.$emit("linked");
    },

    unlinkElements() {
      this.$emit("unlinked");
    },

    closePicker() {
      this.addingElement = false;
    },

    openPicker() {
      if (this.addingElement) {
        this.addingElement = false;
      } else {
        EventBus.$emit("close-pickers");
        this.addingElement = true;
      }
    },
  },

  computed: {
    buttonMessage() {
      if (this.addingElement) {
        return "Cancel";
      } else {
        return "Add narrative element";
      }
    },
  },

  mounted() {
    EventBus.$on("close-pickers", this.closePicker);
  },
};
</script>

<style>
.borderless {
  opacity: 0;
}
.up {
  top: -8px;
  z-index: 1000;
}
.linked {
  color: #3b82f6 !important;
  /* color: blue !important */
}
</style>
